import { memoize } from 'lodash';
// @ts-ignore
import type * as RCL from 'rclnodejs';

import { makeLogNamespace } from '@sb/log/log';

const log = makeLogNamespace('ROS.getRCL');

let isInitialized = false;

// get ROS2 Client Library and initialize
export const getRCL = memoize(async (): Promise<typeof RCL> => {
  try {
    // @ts-ignore
    const { default: rcl } = await import('rclnodejs');

    await rcl.init();
    isInitialized = true;

    return rcl;
  } catch (error) {
    log.error('init.error', 'ROS did not initialize', { error });
    throw error;
  }
});

export async function shutdownROS(): Promise<void> {
  if (!isInitialized) {
    log.info('shutdown.ros', 'ROS was not initialized, skipping shutdown');

    return;
  }

  try {
    log.info('shutdown.ros', 'shutting down ros');
    const rcl = await getRCL();
    await rcl.shutdown();
    isInitialized = false;
  } catch (error) {
    log.error('shutdown.error', 'Failed to shutdown ROS', { error });
  }
}
